import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User moved a board',
  name: 'moved_boards',
  params: [
    {
      description: 'The ids of the boards that were moved',
      name: 'board_ids',
      required: true,
      type: 'array',
      values: ['string'],
    },
    {
      description: 'New board id, empty if board is moved to root',
      name: 'new_parent_board_id',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Id of the library the board was moved to',
      name: 'new_library_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
